export type FileUploadResponse = {
  etag: string;
  key: string;
  contentType: string;
};

export const MAX_SIZE_MB = 8;
